import { useCallback } from 'react';
import { ModalOverlay, ModalDialog, Button } from '@flos/react-ui';

import { useConfigContext } from '../../context/ConfigContext';
import { ProductNames } from '../../interfaces/interfaces';
import { RenderHtml } from '../../components/shared/RenderHtml';

/* ============================================ Local Constants ============================================ */
const ID_MODAL = 'modal-giftcard';

/* ============================================ Local Types ============================================ */
interface IProps {
    show: boolean;
    title: string;
    content: string;
    amount: string;
    closeHandler: Function;
}

/* ============================================ Local Functions ============================================ */
const getUserFriendlyProductName = (product: ProductNames): string => {
    switch (product) {
        case ProductNames.CAR:
            return 'bilforsikring';
        case ProductNames.CHILD:
            return 'boerneforsikring';
        default:
            return 'forsikring';
    }
};

/* ============================================ Main Component ============================================ */
const GiftcardModal = ({ show, title, content, amount, closeHandler }: IProps): React.JSX.Element => {
    const { product } = useConfigContext();

    const handleOnDismiss = useCallback(() => {
        closeHandler();
    }, [closeHandler]);

    return (
        <>
            <ModalOverlay id={ID_MODAL} data-testid={ID_MODAL} isOpen={show} onDismiss={handleOnDismiss}>
                <ModalDialog position="center" closeIconHandler={handleOnDismiss}>
                    <div className="u-spacing-inset-xl">
                        <div className={'u-flex-box u-flex-box--space-between u-spacing-stack-l'}>
                            <h3 className="u-spacing-stack-none">{title}</h3>
                        </div>

                        <RenderHtml className="u-spacing-stack-m">
                            {content
                                .replace('{amount}', Intl.NumberFormat('da-DK').format(parseInt(amount)))
                                .replaceAll('{product}', getUserFriendlyProductName(product))
                                .replaceAll('{the_product}', `${getUserFriendlyProductName(product)}en`)}
                        </RenderHtml>

                        <Button className="flos-button flos-button--secondary" onClick={handleOnDismiss}>
                            Tilbage
                        </Button>
                    </div>
                </ModalDialog>
            </ModalOverlay>
        </>
    );
};

export default GiftcardModal;
